const headerStyle = () => {
  return {
    borderColor: '#a81933'
  };
};

export const columns = [
  {    
    dataField: 'name',
    text: 'Name',
    sort: true,
    headerStyle: headerStyle
  },
  {
    dataField: 'stateName',
    text: 'State',
    sort: true,
    headerStyle: headerStyle
  }
];

export const sorting = [{
  dataField: 'name',
  order: 'asc'
}];